import classNames from "classnames";

import style from "./UserName.module.css";

interface UserNameProps {
  name: string;
  isCurrentUser?: boolean;
}

export const UserName = ({ name, isCurrentUser }: UserNameProps) => {
  const initial = [...name.replace(/[()]/g, "")][0];
  return (
    <div className={style.wrapper}>
      <div className={classNames([style.avatar])}>{initial}</div>
      <span className={style.name} title={name}>
        {name}
      </span>
      {isCurrentUser && <span className={style.youBadge}>(You)</span>}
    </div>
  );
};
